export default __webpack_public_path__ + "static/media/vasa-aktivita.10e65853.svg";